module.exports = __webpack_public_path__ + "static/media/A1C.be6d84c1.png";